import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { familyData, FamilyMember } from '../../data/family';
import { MemberNode } from './MemberNode';
interface FamilyTreeProps {
  selectedId: string | null;
  onSelect: (member: FamilyMember) => void;
}
export function FamilyTree({
  selectedId,
  onSelect
}: FamilyTreeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [constraints, setConstraints] = useState({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  });
  // Canvas size
  const CANVAS_WIDTH = 1200;
  const CANVAS_HEIGHT = 900;
  useEffect(() => {
    if (containerRef.current) {
      const {
        clientWidth,
        clientHeight
      } = containerRef.current;
      setConstraints({
        top: Math.min(0, clientHeight - CANVAS_HEIGHT),
        left: Math.min(0, clientWidth - CANVAS_WIDTH),
        right: 0,
        bottom: 0
      });
    }
  }, []);
  // Generate SVG paths for connections
  const connections = familyData.flatMap(child => {
    if (!child.parents) return [];
    return child.parents.map(parentId => {
      const parent = familyData.find(p => p.id === parentId);
      if (!parent) return null;
      // Draw a smooth S-curve from parent to child
      const startX = parent.x;
      const startY = parent.y + 40; // slightly below center
      const endX = child.x;
      const endY = child.y - 40; // slightly above center
      const midY = (startY + endY) / 2;
      const path = `M ${startX} ${startY} C ${startX} ${midY}, ${endX} ${midY}, ${endX} ${endY}`;
      return <path key={`${parentId}-${child.id}`} d={path} fill="none" stroke="#3d302a" // warm-border
      strokeWidth="3" strokeLinecap="round" className="transition-all duration-500" style={{
        stroke: selectedId === parentId || selectedId === child.id ? '#22d3ee' : '#3d302a',
        opacity: selectedId === parentId || selectedId === child.id ? 0.6 : 1
      }} data-id="element-117" />;
    });
  });
  return <div ref={containerRef} className="w-full h-screen overflow-hidden bg-warm-bg relative cursor-grab active:cursor-grabbing" data-id="element-118">
      {/* Noise Overlay */}
      <div className="absolute inset-0 bg-noise z-0" data-id="element-119" />

      <motion.div drag dragConstraints={constraints} dragElastic={0.1} dragMomentum={false} initial={{
      x: -100,
      y: 0
    }} // Slight offset to center the tree on load
    className="absolute top-0 left-0" style={{
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT
    }} data-id="element-120">
        {/* SVG Connectors */}
        <svg className="absolute inset-0 pointer-events-none z-10" width={CANVAS_WIDTH} height={CANVAS_HEIGHT} data-id="element-121">
          {connections}
        </svg>

        {/* Nodes */}
        {familyData.map(member => <MemberNode key={member.id} member={member} isSelected={selectedId === member.id} onClick={() => onSelect(member)} data-id="element-122" />)}
      </motion.div>
    </div>;
}